<div class="widget-campaign-filter-flyout">
  <div class="content">
    <div class="title-row">
      <div class="title-text-group">
        <mat-icon>tune</mat-icon>
        <div class="title-text">
          {{ "campaign.filter.title" | translate }} {{ this.currentCampaignFilter?.name ? " - " + this.currentCampaignFilter?.name : "" }}
          @if (isFilterChanged && $safeNavigationMigration(this.currentCampaignFilter?.id) !== undefined) {
            <span>*</span>
          }
        </div>
      </div>
      <div class="header-close-icon">
        <mat-icon class="close-icon" (click)="cancelFlyout()">close</mat-icon>
      </div>
    </div>
    <div class="type-filter-wrapper">
      <h3>{{ "campaign.filter.type" | translate }}</h3>
      <mat-chip-listbox multiple aria-label="Color selection">
        @for (chip of typeFilter; track chip) {
          <mat-chip-option [disabled]="chip?.disabled" [selected]="chip?.selected" (selectionChange)="onSelectionChange($event, 'typeFilter')">
            {{ chip?.name }}
          </mat-chip-option>
        }
      </mat-chip-listbox>
    </div>
    @if (!isBackoffice) {
      <div class="type-filter-wrapper">
        <h3>{{ "campaign.filter.tags" | translate }}</h3>
        <mat-chip-listbox multiple aria-label="Color selection">
          @for (tag of campaignTags; track tag) {
            <mat-chip-option [value]="tag" [selected]="tag?.selected" (selectionChange)="onSelectionChangeTags($event, tag)">
              {{ tag?.name }} ({{ tag?.usageCount }})
            </mat-chip-option>
          }
        </mat-chip-listbox>
      </div>
    }

    @if (flyoutOpeningData.pageTitle === "filter-all") {
      <div class="content-filter-wrapper">
        <h3>{{ "campaign.filter.content.title" | translate }}</h3>
        <mat-chip-listbox multiple aria-label="Color selection">
          @for (chip of contentFilter; track chip) {
            <mat-chip-option [disabled]="chip?.disabled" [selected]="chip?.selected" (selectionChange)="onSelectionChange($event, 'contentFilter')">
              {{ chip?.name }}
            </mat-chip-option>
          }
        </mat-chip-listbox>
      </div>
    }

    @if (flyoutOpeningData.pageTitle === "filter-all") {
      <div class="content-filter-wrapper">
        <h3>{{ "campaign.filter.components" | translate }}</h3>
        <mat-chip-listbox aria-label="Color selection">
          @for (chip of components; track chip) {
            <mat-chip-option [disabled]="chip?.disabled" [selected]="chip?.selected" (selectionChange)="onComponentChange($event, chip.value)">
              {{ chip.name }}
            </mat-chip-option>
          }
        </mat-chip-listbox>
      </div>
    }

    @if (flyoutOpeningData.pageTitle === "filter-all") {
      <div class="steps-and-variations-wrapper">
        @if (comparisonFilterForm) {
          <form [formGroup]="comparisonFilterForm">
            <div formGroupName="variationsFilter">
              <h3>{{ "campaign.filter.steps-and-variations" | translate }}</h3>
              <mat-form-field class="field-input" appearance="outline">
                <mat-label>{{ "campaign.filter.content.variations" | translate }}</mat-label>
                <mat-select class="comparison-selector" formControlName="comparison">
                  <mat-option value="">{{ "campaign.filter.date.no-date" | translate }}</mat-option>
                  <mat-option value="greaterThanOrEqual">{{ "campaign.filter.comparisonOperatorTypes.greaterThanOrEqual" | translate }}</mat-option>
                  <mat-option value="lessThanOrEqual">{{ "campaign.filter.comparisonOperatorTypes.lessThanOrEqual" | translate }}</mat-option>
                  <mat-option value="between">{{ "campaign.filter.comparisonOperatorTypes.between" | translate }}</mat-option>
                </mat-select>
              </mat-form-field>
              @if (
                comparisonFilterForm.get("variationsFilter.comparison").value === "greaterThanOrEqual" ||
                comparisonFilterForm.get("variationsFilter.comparison").value === "lessThanOrEqual"
              ) {
                <div class="greater-lesser-input">
                  <mat-form-field class="field-input" appearance="outline">
                    @if (comparisonFilterForm.get("variationsFilter.comparison").value === "greaterThanOrEqual") {
                      <mat-label>{{ "campaign.filter.comparisonOperatorTypes.greaterThanOrEqual" | translate }}</mat-label>
                    }
                    @if (comparisonFilterForm.get("variationsFilter.comparison").value === "lessThanOrEqual") {
                      <mat-label>{{ "campaign.filter.comparisonOperatorTypes.lessThanOrEqual" | translate }}</mat-label>
                    }
                    <input matInput type="number" formControlName="value" />
                  </mat-form-field>
                </div>
              }
              @if (comparisonFilterForm.get("variationsFilter.comparison").value === "between") {
                <div class="between-comparison-inputs">
                  <mat-form-field class="field-input" appearance="outline">
                    <mat-label>{{ "campaign.filter.comparisonOperatorTypes.minimum" | translate }}</mat-label>
                    <input class="comparison-number-input" matInput type="number" formControlName="value" />
                  </mat-form-field>
                  <span>-</span>
                  <mat-form-field class="field-input" appearance="outline">
                    <mat-label>{{ "campaign.filter.comparisonOperatorTypes.maximum" | translate }}</mat-label>
                    <input class="comparison-number-input" matInput type="number" formControlName="valueTo" />
                  </mat-form-field>
                </div>
              }
            </div>
            <div formGroupName="stepsFilter">
              <mat-form-field class="field-input" appearance="outline">
                <mat-label>{{ "campaign.filter.content.steps" | translate }}</mat-label>
                <mat-select class="comparison-selector" formControlName="comparison">
                  <mat-option value="">{{ "campaign.filter.date.no-date" | translate }}</mat-option>
                  <mat-option value="greaterThanOrEqual">{{ "campaign.filter.comparisonOperatorTypes.greaterThanOrEqual" | translate }}</mat-option>
                  <mat-option value="lessThanOrEqual">{{ "campaign.filter.comparisonOperatorTypes.lessThanOrEqual" | translate }}</mat-option>
                  <mat-option value="between">{{ "campaign.filter.comparisonOperatorTypes.between" | translate }}</mat-option>
                </mat-select>
              </mat-form-field>
              @if (
                comparisonFilterForm.get("stepsFilter.comparison").value === "greaterThanOrEqual" ||
                comparisonFilterForm.get("stepsFilter.comparison").value === "lessThanOrEqual"
              ) {
                <div class="greater-lesser-input">
                  <mat-form-field class="field-input" appearance="outline">
                    @if (comparisonFilterForm.get("stepsFilter.comparison").value === "greaterThanOrEqual") {
                      <mat-label>{{ "campaign.filter.comparisonOperatorTypes.greaterThanOrEqual" | translate }}</mat-label>
                    }
                    @if (comparisonFilterForm.get("stepsFilter.comparison").value === "lessThanOrEqual") {
                      <mat-label>{{ "campaign.filter.comparisonOperatorTypes.lessThanOrEqual" | translate }}</mat-label>
                    }
                    <input matInput type="number" formControlName="value" />
                  </mat-form-field>
                </div>
              }
              @if (comparisonFilterForm.get("stepsFilter.comparison").value === "between") {
                <div class="between-comparison-inputs">
                  <mat-form-field class="field-input" appearance="outline">
                    <mat-label>{{ "campaign.filter.comparisonOperatorTypes.minimum" | translate }}</mat-label>
                    <input class="comparison-number-input" matInput type="number" formControlName="value" />
                  </mat-form-field>
                  <span>-</span>
                  <mat-form-field class="field-input" appearance="outline">
                    <mat-label>{{ "campaign.filter.comparisonOperatorTypes.maximum" | translate }}</mat-label>
                    <input class="comparison-number-input" matInput type="number" formControlName="valueTo" />
                  </mat-form-field>
                </div>
              }
            </div>
          </form>
        }
      </div>
    }

    <div class="type-filter-wrapper">
      <h3>{{ "campaign.filter.status" | translate }}</h3>
      <mat-chip-listbox multiple aria-label="Color selection">
        @for (chip of statusFilter; track chip) {
          <mat-chip-option [selected]="chip?.selected" (selectionChange)="onSelectionChange($event, 'statusFilter')">
            {{ chip?.name }}
          </mat-chip-option>
        }
      </mat-chip-listbox>
    </div>

    <div class="date-filter-wrapper">
      <h3>{{ "campaign.filter.date.title" | translate }}</h3>
      <form [formGroup]="filterForm">
        <mat-form-field class="field-input" appearance="outline">
          <mat-label>{{ "campaign.filter.date.filter-type" | translate }}</mat-label>
          <mat-select formControlName="filterType">
            <mat-option value="">{{ "campaign.filter.date.no-date" | translate }}</mat-option>
            <mat-option value="createdTime">{{ "campaign.filter.date.created" | translate }}</mat-option>
            <mat-option value="lastUpdated">{{ "campaign.filter.date.last-updated" | translate }}</mat-option>
            <mat-option value="lastPublished">{{ "campaign.filter.date.last-published" | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
        <div formGroupName="dateFilter">
          @if (
            filterForm.get("filterType").value === "createdTime" ||
            filterForm.get("filterType").value === "lastUpdated" ||
            filterForm.get("filterType").value === "lastPublished"
          ) {
            <div class="date-container">
              <mat-form-field appearance="outline" class="centered-label">
                @if (filterForm.get("dateFilter.from").value) {
                  <button class="clear-button" mat-icon-button matSuffix aria-label="Clear" (click)="clearFromDate(fromInput)">
                    <mat-icon>close</mat-icon>
                  </button>
                }
                <mat-label>{{ "campaign.filter.date.from" | translate }}</mat-label>
                <input matInput [matDatepicker]="picker1" formControlName="from" #fromInput />
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
              </mat-form-field>

              <mat-form-field appearance="outline">
                @if (filterForm.get("dateFilter.to").value) {
                  <button class="clear-button" mat-icon-button matSuffix aria-label="Clear" (click)="clearToDate()">
                    <mat-icon>close</mat-icon>
                  </button>
                }
                <mat-label>{{ "campaign.filter.date.to" | translate }}</mat-label>
                <input matInput [matDatepicker]="picker2" formControlName="to" />
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
              </mat-form-field>
            </div>
          }
        </div>
      </form>
    </div>

    <div class="name-filter-wrapper">
      <mat-form-field appearance="outline">
        <mat-label>{{ "campaign.filter.campaign-name-search" | translate }}</mat-label>
        <input [formControl]="searchControl" matInput placeholder="{{ 'campaign.filter.campaign-name-place-holder' | translate }}" />
      </mat-form-field>
    </div>
    @if (flyoutOpeningData.pageTitle === "filter-all") {
      <div class="account-filter-wrapper">
        <mat-form-field class="field-input" appearance="outline">
          <mat-label>{{ "campaign.filter.account.filter-type" | translate }}</mat-label>
          <mat-select [formControl]="accountControl" multiple>
            @for (account of filteredBackofficeAccounts; track account) {
              <mat-option [value]="account.id">
                {{ account.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    @if (flyoutOpeningData.pageTitle === "filter-all") {
      <div class="numerical-comparison-filter-wrapper statistics-wrapper">
        @if (comparisonFilterForm) {
          <form [formGroup]="comparisonFilterForm">
            <div formGroupName="viewsFilter">
              <h3>{{ "campaign.filter.statistics.statistics" | translate }}</h3>
              <mat-form-field class="field-input" appearance="outline">
                <mat-label>{{ "campaign.filter.statistics.views" | translate }}</mat-label>
                <mat-select class="comparison-selector" formControlName="comparison">
                  <mat-option value="">{{ "campaign.filter.date.no-date" | translate }}</mat-option>
                  <mat-option value="greaterThanOrEqual">{{ "campaign.filter.comparisonOperatorTypes.greaterThanOrEqual" | translate }}</mat-option>
                  <mat-option value="lessThanOrEqual">{{ "campaign.filter.comparisonOperatorTypes.lessThanOrEqual" | translate }}</mat-option>
                  <mat-option value="between">{{ "campaign.filter.comparisonOperatorTypes.between" | translate }}</mat-option>
                </mat-select>
              </mat-form-field>
              @if (
                comparisonFilterForm.get("viewsFilter.comparison").value === "greaterThanOrEqual" ||
                comparisonFilterForm.get("viewsFilter.comparison").value === "lessThanOrEqual"
              ) {
                <div class="greater-lesser-input">
                  <mat-form-field class="field-input" appearance="outline">
                    @if (comparisonFilterForm.get("viewsFilter.comparison").value === "greaterThanOrEqual") {
                      <mat-label>{{ "campaign.filter.comparisonOperatorTypes.greaterThanOrEqual" | translate }}</mat-label>
                    }
                    @if (comparisonFilterForm.get("viewsFilter.comparison").value === "lessThanOrEqual") {
                      <mat-label>{{ "campaign.filter.comparisonOperatorTypes.lessThanOrEqual" | translate }}</mat-label>
                    }
                    <input matInput type="number" formControlName="value" />
                  </mat-form-field>
                </div>
              }
              @if (comparisonFilterForm.get("viewsFilter.comparison").value === "between") {
                <div class="between-comparison-inputs">
                  <mat-form-field class="field-input" appearance="outline">
                    <mat-label>{{ "campaign.filter.comparisonOperatorTypes.minimum" | translate }}</mat-label>
                    <input class="comparison-number-input" matInput type="number" formControlName="value" />
                  </mat-form-field>
                  <span>-</span>
                  <mat-form-field class="field-input" appearance="outline">
                    <mat-label>{{ "campaign.filter.comparisonOperatorTypes.maximum" | translate }}</mat-label>
                    <input class="comparison-number-input" matInput type="number" formControlName="valueTo" />
                  </mat-form-field>
                </div>
              }
            </div>
            <div formGroupName="formResponsesFilter">
              <mat-form-field class="field-input" appearance="outline">
                <mat-label>{{ "campaign.filter.statistics.formResponses" | translate }}</mat-label>
                <mat-select class="comparison-selector" formControlName="comparison">
                  <mat-option value="">{{ "campaign.filter.date.no-date" | translate }}</mat-option>
                  <mat-option value="greaterThanOrEqual">{{ "campaign.filter.comparisonOperatorTypes.greaterThanOrEqual" | translate }}</mat-option>
                  <mat-option value="lessThanOrEqual">{{ "campaign.filter.comparisonOperatorTypes.lessThanOrEqual" | translate }}</mat-option>
                  <mat-option value="between">{{ "campaign.filter.comparisonOperatorTypes.between" | translate }}</mat-option>
                </mat-select>
              </mat-form-field>
              @if (
                comparisonFilterForm.get("formResponsesFilter.comparison").value === "greaterThanOrEqual" ||
                comparisonFilterForm.get("formResponsesFilter.comparison").value === "lessThanOrEqual"
              ) {
                <div class="greater-lesser-input">
                  <mat-form-field class="field-input" appearance="outline">
                    @if (comparisonFilterForm.get("formResponsesFilter.comparison").value === "greaterThanOrEqual") {
                      <mat-label>{{ "campaign.filter.comparisonOperatorTypes.greaterThanOrEqual" | translate }}</mat-label>
                    }
                    @if (comparisonFilterForm.get("formResponsesFilter.comparison").value === "lessThanOrEqual") {
                      <mat-label>{{ "campaign.filter.comparisonOperatorTypes.lessThanOrEqual" | translate }}</mat-label>
                    }
                    <input matInput type="number" formControlName="value" />
                  </mat-form-field>
                </div>
              }
              @if (comparisonFilterForm.get("formResponsesFilter.comparison").value === "between") {
                <div class="between-comparison-inputs">
                  <mat-form-field class="field-input" appearance="outline">
                    <mat-label>{{ "campaign.filter.comparisonOperatorTypes.minimum" | translate }}</mat-label>
                    <input class="comparison-number-input" matInput type="number" formControlName="value" />
                  </mat-form-field>
                  <span>-</span>
                  <mat-form-field class="field-input" appearance="outline">
                    <mat-label>{{ "campaign.filter.comparisonOperatorTypes.maximum" | translate }}</mat-label>
                    <input class="comparison-number-input" matInput type="number" formControlName="valueTo" />
                  </mat-form-field>
                </div>
              }
            </div>
            <div formGroupName="clickthroughsFilter">
              <mat-form-field class="field-input" appearance="outline">
                <mat-label>{{ "campaign.filter.statistics.clickthroughs" | translate }}</mat-label>
                <mat-select class="comparison-selector" formControlName="comparison">
                  <mat-option value="">{{ "campaign.filter.date.no-date" | translate }}</mat-option>
                  <mat-option value="greaterThanOrEqual">{{ "campaign.filter.comparisonOperatorTypes.greaterThanOrEqual" | translate }}</mat-option>
                  <mat-option value="lessThanOrEqual">{{ "campaign.filter.comparisonOperatorTypes.lessThanOrEqual" | translate }}</mat-option>
                  <mat-option value="between">{{ "campaign.filter.comparisonOperatorTypes.between" | translate }}</mat-option>
                </mat-select>
              </mat-form-field>
              @if (
                comparisonFilterForm.get("clickthroughsFilter.comparison").value === "greaterThanOrEqual" ||
                comparisonFilterForm.get("clickthroughsFilter.comparison").value === "lessThanOrEqual"
              ) {
                <div class="greater-lesser-input">
                  <mat-form-field class="field-input" appearance="outline">
                    @if (comparisonFilterForm.get("clickthroughsFilter.comparison").value === "greaterThanOrEqual") {
                      <mat-label>{{ "campaign.filter.comparisonOperatorTypes.greaterThanOrEqual" | translate }}</mat-label>
                    }
                    @if (comparisonFilterForm.get("clickthroughsFilter.comparison").value === "lessThanOrEqual") {
                      <mat-label>{{ "campaign.filter.comparisonOperatorTypes.lessThanOrEqual" | translate }}</mat-label>
                    }
                    <input matInput type="number" formControlName="value" />
                  </mat-form-field>
                </div>
              }
              @if (comparisonFilterForm.get("clickthroughsFilter.comparison").value === "between") {
                <div class="between-comparison-inputs">
                  <mat-form-field class="field-input" appearance="outline">
                    <mat-label>{{ "campaign.filter.comparisonOperatorTypes.minimum" | translate }}</mat-label>
                    <input class="comparison-number-input" matInput type="number" formControlName="value" />
                  </mat-form-field>
                  <span>-</span>
                  <mat-form-field class="field-input" appearance="outline">
                    <mat-label>{{ "campaign.filter.comparisonOperatorTypes.maximum" | translate }}</mat-label>
                    <input class="comparison-number-input" matInput type="number" formControlName="valueTo" />
                  </mat-form-field>
                </div>
              }
            </div>
          </form>
        }
      </div>
    }
  </div>

  @if (flyoutOpeningData.pageTitle !== "filter-all") {
    <div class="button-row">
      @if (pageTitle !== "customer-dashboard") {
        <button
          disabled="{{ this.currentCampaignFilter?.id === null || this.currentCampaignFilter?.id === undefined || this.currentCampaignFilter?.id < 0 }}"
          class="filter-delete-button"
          mat-icon-button
          [hidden]="this.currentCampaignFilter?.id === null || this.currentCampaignFilter?.id === undefined || this.currentCampaignFilter?.id < 0"
          deleteDialog
          deletionTypeText="{{ this.currentCampaignFilter?.name }}"
          deletionTypeHeader="{{ 'confirmationDialog.delete-header-filter' }}"
          deletionText="{{ 'confirmationDialog.delete-message' }}"
          (onDelete)="deleteFilter()">
          <mat-icon fontSet="material-symbols-outlined">delete</mat-icon>
          &nbsp;
        </button>
      }
      <!-- CLEAR BUTTON -->
      <button
        mat-stroked-button
        class="secondary-button clear-button"
        [ngClass]="{
          'no-delete-button':
            !(this.currentCampaignFilter?.id === null || this.currentCampaignFilter?.id === undefined || this.currentCampaignFilter?.id < 0) ||
            pageTitle === 'customer-dashboard',
        }"
        [disabled]="!this?.isFilterChanged"
        (click)="resetFilter()">
        {{ "generic.reset" | translate }}
      </button>
      <!-- Save BUTTON -->
      @if (pageTitle !== "customer-dashboard") {
        <button
          mat-stroked-button
          class="secondary-button save-button"
          [disabled]="this.currentCampaignFilter?.id < 0 || !this?.isFilterChanged"
          (click)="saveFilter()">
          @if (this.currentCampaignFilter?.id === null || this.currentCampaignFilter?.id === undefined) {
            {{ "generic.create" | translate }}
          } @else {
            {{ "generic.save" | translate }}
          }
        </button>
      }
      <!-- APPLY BUTTON -->
      <button mat-stroked-button class="primary-button apply-button" (click)="cancelFlyout()">
        {{ "generic.apply" | translate }}
      </button>
    </div>
  }
</div>
